import fp from "lodash/fp"

import { darkTheme } from "styles/themes"
import type {
  GaugePlotView,
  PiePlotView,
  ScatterPlotView,
  SingleStatPlotView,
  LinePlotView,
} from "types/dashboard.types"

const THEME_PALETTE_EXTRAS = fp.flow(fp.values, fp.map("main"))(darkTheme.palette.extras)

export const gaugeView: GaugePlotView = {
  name: "",
  nameKey: "",
  type: "gauge",
  properties: {
    colors: [
      { id: "0", type: "min", hex: "#BF3D5E", name: "ruby", value: 0 },
      { id: "1", type: "max", hex: "#7CE490", name: "honeydew", value: 100 },
    ],
    formatUnits: false,
    decimalPlaces: 0,
    prefix: "",
    suffix: "",
    tickPrefix: "",
    tickSuffix: "",
  },
}

export const lineView: LinePlotView = {
  name: "",
  nameKey: "",
  type: "xy",
  properties: {
    axes: {
      x: {
        type: "time",
        scaleType: "time",
        key: "_time",
        label: "",
        bounds: ["", ""],
        totalTicks: 10,
      },
      y: {
        type: "number",
        scaleType: "linear",
        key: "_value",
        label: "",
        prefix: "",
        suffix: "",
        bounds: ["", ""],
        base: "10",
        decimalPlaces: 2,
        formatUnits: true,
        totalTicks: 5,
      },
    },
    showMarks: true,
    connectNulls: true,
    fill: ["_field"],
    timeFormat: "yyyy-MM-dd HH:mm",
    curve: "monotoneX",
    colors: [
      darkTheme.palette.primary.main,
      darkTheme.palette.secondary.main,
      ...THEME_PALETTE_EXTRAS,
    ],
    margin: { top: 15, right: 30, bottom: 15, left: 0 },
    grid: { vertical: true, horizontal: true },
    tooltip: {
      trigger: "axis",
    },
    legend: {
      hidden: true,
    },
    lineWidth: 1.5,
  },
}

export const singleStatView: SingleStatPlotView = {
  name: "",
  nameKey: "",
  type: "single-stat",
  properties: {
    prefix: "",
    suffix: "",
    decimalPlaces: 0,
    size: "md",
    formatUnits: false,
  },
}

export const pieView: PiePlotView = {
  name: "",
  nameKey: "",
  type: "pie",
  properties: {
    decimalPlaces: 0,
    prefix: "",
    suffix: "",
    colors: [],
  },
}

export const scatterView: ScatterPlotView = {
  name: "",
  nameKey: "",
  type: "scatter",
  properties: {
    axes: {
      x: {
        type: "time",
        scaleType: "time",
        key: "_time",
        label: "",
        bounds: ["", ""],
        totalTicks: 10,
      },
      y: {
        type: "number",
        scaleType: "linear",
        key: "_value",
        label: "",
        prefix: "",
        suffix: "",
        bounds: ["", ""],
        base: "10",
        decimalPlaces: 2,
        formatUnits: true,
        totalTicks: 5,
      },
    },
    fill: ["_field"],
    timeFormat: "yyyy-MM-dd HH:mm",
    colors: [
      darkTheme.palette.primary.main,
      darkTheme.palette.secondary.main,
      ...THEME_PALETTE_EXTRAS,
    ],
    margin: { top: 15, right: 25, bottom: 15, left: 0 },
    grid: { vertical: true, horizontal: true },
    tooltip: {
      trigger: "item",
    },
    legend: {
      hidden: true,
    },
    markerSize: 3,
    highlightScope: { highlight: "item", fade: "global" },
  },
}
